
/* prettier-ignore */

import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'select-google-lang',
  templateUrl: './select-google-lang.component.html',
  styleUrl: './select-google-lang.component.scss',
})

export class SelectGoogleLanguageComponent {
  private _translationService = inject(TranslationService);

  selectedLang: string;
  langs = this._translationService.googleLanguages;

  constructor(
    public modalCtrl: ModalController
  ) {}

  changeLang(){
    this._translationService.changeLanguage(this.selectedLang);
  }

  dismissModal() {
    this.modalCtrl.dismiss().catch(e => {
      console.warn("No modal found on dismiss")
    });
  }
}
